module.exports = __webpack_public_path__ + "img/logo42.426cb35c.png";